import React from 'react';

import { HpmsCustomContentCollapseEvent, HPMSOnOpen } from '@philips-emr/hpms-components';
import { Stamp, StampIcon } from '@philips-emr/tws-components';
import { Color } from '@philips-emr/tws-constants';
import Controller, { OnDynamicContentRender, OnMount, OnUnmount } from '@philips-emr/tws-core/lib/client';
import { MountEvent, RenderEvent } from '@philips-emr/tws-core/lib/component/types';

import { FragmentNames } from '../../codegen';
import { HistoricoProtocolosAliases } from '../../codegen/constants/aliases/historico-protocolos-aliases';
import FilterService from '../../services/filter-service';
import BaseController from '../base/base-controller';

interface Protocol {
  nrSeqProtocolo: number,
}
@Controller({ fragment: FragmentNames.HISTORICO_PROTOCOLOS })
export default class HistoricoProtocolosController extends BaseController {

  @OnMount(HistoricoProtocolosAliases.FILTER)
  onFilterMount = (event: MountEvent): void => FilterService.restoreFilterState(event);

  @OnUnmount(HistoricoProtocolosAliases.FILTER)
  onFilterUnmount = (event: MountEvent): void => FilterService.persistFilterState(event);

  @OnDynamicContentRender(HistoricoProtocolosAliases.CUSTOM_CARD)
  onDynamicContentRender({ data, render }: RenderEvent): void {
    const { ieStatus } = data as { ieStatus: number };

    const props: { [key: number]: {} } = {
      1: { icon: StampIcon.CLOCK, color: Color.SAFETY_NEUTRAL },
      2: { icon: StampIcon.CLOCK, color: Color.SAFETY_BLUE },
      3: { icon: StampIcon.CHECK, color: Color.SAFETY_GREEN },
      4: { icon: StampIcon.CANCELED, color: Color.SAFETY_RED },
    };

    render(() => <Stamp {...props[ieStatus]} label={`@beneficiary.status-protocolo-atendimento/${ieStatus}`} />);
  }

  @HPMSOnOpen(HistoricoProtocolosAliases.HPMS_CUSTOM_CARD_CONTENT_COLLAPE)
  onOpen(event: HpmsCustomContentCollapseEvent<Protocol>): void {
    const { onOpenRender } = event;
    const { nrSeqProtocolo } = event.data;
    const { nrSeqBeneficiario } = this.context.getBulkData();
    onOpenRender({ parameters: { nrSeqBeneficiario, nrSeqProtocolo } });
  }
}
